import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    offlineIconWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
    },
    offlineIconLabel: {
        fontSize: 12,
        fontWeight: 700,
        fontFamily: "Source Sans 3",
        color: theme.palette.primary.main,
    },
    circle: {
        width: 72,
        height: 72,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "100%",
        "& svg": {
            color: theme.palette.primary.main,
            width: 32,
            height: 32,
        },
        "& img": {
            height: 32,
        },
    },
    bigCircle: {
        width: 80,
        height: 80,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "100%",
        "& svg": {
            color: theme.palette.primary.main,
            width: 40,
            height: 40,
        },
        "& img": {
            height: 40,
        },
    },
    offline: {
        background: theme.palette.warning.main,
    },
    up: {
        background: theme.palette.success.main,
    },
    down: {
        background: theme.palette.error.main,
    },
    endOfShift: {
        background: theme.palette.corporateBO.checkbox,
    },
    belowTrigger: {
        background: theme.palette.hmi.pausedBackground,
        border: `1px solid ${theme.palette.hmi.pausedColor}`,
        "& .MuiSvgIcon-root": {
            color: theme.palette.hmi.pausedColor,
        },
    },
    noData: {
        background: theme.palette.info.main,
    },
    bigIcon: {
        width: "40px !important",
        height: "40px !important",
    },
    bigImage: {
        height: "40px !important",
    },
    bottleImage: {
        filter: "invert(100%)",
    },
}));
